import { CopyIcon, EditIcon, TrashIcon } from "assets";
import { CustomTooltip, SmallScreenModel } from "components";
import React, { useState } from "react";
import { MembershipDurationsProps } from "../store/actionType";
import HandleUpdateMembershipDuration from "./manage_membership_duration/HandleUpdateMembershipDuration";
import HandleDeleteMembersgipDuration from "./manage_membership_duration/HandleDeleteMembersgipDuration";
import { copyToClipboard } from "utils/helpers/CopyToClipboard";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import { SuperAdminStatusEnum } from '../../../../../props/enum';

const ActionButton: React.FC<{ items: MembershipDurationsProps }> = ({
  items,
}) => {
  const { authUser, action, superAdmin } = useUser();
  const [isEditModel, setEditModel] = useState(false);
  const [isDeleteModel, setDeleteModel] = useState(false);
  const [copied, setCopied] = useState(false);
  const handleCopy = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    const success = await copyToClipboard(items.id ?? "");
    if (success) {
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 1500);
    }
  };
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.UPDATE_COMMERCIAL_MEMBERSHIP_DURATION));
  if (isPermitted)
    return (
      <>
        <div className="flex flex-row gap-2 justify-center">
          <CustomTooltip title="Edit" placement="bottom">
            <button
              className="hover:text-primary-500"
              onClick={() => setEditModel(true)}
            >
              <EditIcon />
            </button>
          </CustomTooltip>
          <CustomTooltip title="Delete" placement="bottom">
            <button
              className="hover:text-red-500"
              onClick={() => setDeleteModel(true)}
            >
              <TrashIcon className="" />
            </button>
          </CustomTooltip>
          <CustomTooltip
            title={copied ? "Id copied!" : "Copy Duration Id"}
            placement="right"
          >
            <button onClick={handleCopy} className="p-1 hover:text-blue-600">
              <CopyIcon className="size-5" />
            </button>
          </CustomTooltip>
        </div>
        <SmallScreenModel setShowModal={setEditModel} showModal={isEditModel}>
          <HandleUpdateMembershipDuration
            membershipData={items}
            closeModal={setEditModel}
          />
        </SmallScreenModel>
        <SmallScreenModel
          setShowModal={setDeleteModel}
          showModal={isDeleteModel}
        >
          <HandleDeleteMembersgipDuration
            membershipData={items}
            closeModal={setDeleteModel}
          />
        </SmallScreenModel>
      </>
    );
  return <></>;
};

export default ActionButton;
